import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0901Model } from './kymw0901.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

import { FlexGrid } from '@grapecity/wijmo.grid';
import { TabPanel } from '@grapecity/wijmo.nav';

import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { GetChangeItemListService } from './api-services/get-change-item-list.service';
import { RenewPlanGoodsChangeService } from './api-services/renew-plan-goods-change-manage.service';
import { SaveChangeFixationService } from './api-services/save-change-fixation.service';
import { SaveChangeFixationModel } from './vo/kymw0901-save-change-fixation.model';

/**
 * 変更確認画面を管理するクラス
 *
 * @export KYMW0901Component
 * @class KYMW0901Component
 */
@Component({
  selector: 'app-kymw0901',
  templateUrl: 'kymw0901.component.html',
  styleUrls: ['kymw0901.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0901Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_UpdatedList', { static: true }) dtg_UpdatedList: FlexGrid;
  @ViewChild('tab_Top', { static: true }) tab_Top: TabPanel;

  @ViewChild('btn_SaveChangeFixation', { static: true }) btn_SaveChangeFixation: ElementRef;
  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;

  // 親画面からの連携値
  private param: any;

  // 親画面のfunction
  setKYMW0901Parameter: Function;

  /** 動的タブ タブヘッダに表示するタイトルリスト */ 
  public tabsInfo: Array<any> = [];

  // model定義
  public kymw0901Model: KYMW0901Model = new KYMW0901Model();
  private updatedListData = [];

  // 親画面への連携用
  public editCount = 0;

  /**
   *Creates an instance of KYMW0901Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0901Component
   */
  constructor(
    public dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getChangeItemListService: GetChangeItemListService,
    private renewPlanGoodsChangeService: RenewPlanGoodsChangeService,
    private saveChangeFixationService: SaveChangeFixationService,
  ) {
    super(kymw00Model);

    // タブ表示文字列へ変換する連想配列を設定する（変換できなかった場合はHTMLで非表示）
    this.tabsInfo = [];
    this.tabsInfo['CommonItem'] = '共通';
    this.tabsInfo['CoopItem_142'] = 'い';
    this.tabsInfo['CoopItem_163'] = 'と';
    this.tabsInfo['CoopItem_185'] = 'ぐ';
    this.tabsInfo['CoopItem_240'] = 'ち';
    this.tabsInfo['CoopItem_210'] = 'さ';
    this.tabsInfo['CoopItem_302'] = 'とう';
    this.tabsInfo['CoopItem_515'] = 'な';
    this.tabsInfo['CoopItem_451'] = 'に';
    this.tabsInfo['NextGuide'] = '次回案内';
    this.tabsInfo['LotteryPromotion'] = '抽選';
    this.tabsInfo['Coupon'] = 'クーポン';
    this.tabsInfo['Point'] = 'ポイント';
    this.tabsInfo['NvalPromotion'] = '1物N価';
    this.tabsInfo['EC'] = 'EC';
    this.tabsInfo['PreOrder'] = '予約';
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0901Component
   */
  public ngOnInit(): void {
    this.kymw0901Model.kymw0901Component = this;
    this.componentName = 'KYMW0901';

    // 変更内容取得イベントの発行
    this.getChangeItemListService.execute(this.kymw0901Model);
  }

  /**
   * 親画面の情報設定
   *
   * @param {*} vo
   * @memberof KYMW0901Component
   */
  public setInterfaceParam(vo: any) {
    // 企画商品メンテ画面から受注コードを受け取る
    this.kymw0901Model.orderCode = vo.orderList[0];
    this.kymw0901Model.pCode = vo.orderList[1];
    this.kymw0901Model.pCodeList = vo.orderList[2];
    this.kymw0901Model.textInfoDivArray = vo.textInfoDivArray;
    this.kymw0901Model.textKindNumArray = vo.textKindNumArray;
    this.kymw0901Model.selectedMediumType = vo.selectedMediumType;
  }

  /**
 * grid処理(updatedList)
 * @param grid
 */
  onInitialized(grid: FlexGrid) {
    // ヘッダー行の高さ
    grid.columnHeaders.rows[0].height = 27;
    // 詳細行の高さ
    grid.rows.defaultSize = 27;

    grid.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = grid.hitTest(e);
      if ((0 <= ht.row) && (1 == ht.col))
        if (!ht.target.className.includes("wj-header") && !ht.target.className.includes("wj-glyph-down") && !ht.target.className.includes("wj-glyph-up")) {
        document.getElementById(`cb_updated_${ht.row}`).click();
      }
    });
  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/

  public eventMoveToFocusHandler(event: any): void {
    if (event.keyCode === 9) {
      // 後続のデフォルトイベントをキャンセル
      event.preventDefault();
      let index: number = <number>-1;
      let keyLength: number = <number>-1;
      keyLength = this.kymw0901Model.dataKeys.length;

      index = this.tab_Top.selectedIndex;
      if (!event.shiftKey) {
        switch (index) {
          case keyLength - 1:
            // 「変更確定」ボタンにフォーカス設定
            this.btn_SaveChangeFixation.nativeElement.focus();
            break;
          default:
            this.tab_Top.selectedIndex = index + 1;
            this.dtg_UpdatedList.focus();
            break;
        }
      } else {
        switch (index) {
          case 0:
            // 「閉じる」ボタンにフォーカス設定
            this.btn_Close.nativeElement.focus();
            break;
          default:
            this.tab_Top.selectedIndex = index - 1;
            this.dtg_UpdatedList.focus();
            break;
        }
      }
    }
  }

  /**
   * 閉じるボタンでのキーダウンイベント
   *
   * @param event キーダウンイベント
   */
  public eventMoveFromCloseHandler(event: any): void {
    if (event.keyCode === 9) {
      if (!event.shiftKey) {
        this.tab_Top.selectedIndex = 0;
        this.dtg_UpdatedList.focus();
      } else {
        this.btn_SaveChangeFixation.nativeElement.focus();
      }
      // 後続のデフォルトイベントをキャンセル
      event.preventDefault();
    }
  }

  /**
   * 変更確定ボタンでのキーダウンイベント
   *
   * @param event キーダウンイベント
   */
  public eventMoveFromChangeFixationsHandler(event: any): void {
    if (event.keyCode === 9) {
      if (event.shiftKey) {
        this.tab_Top.selectedIndex = this.tab_Top.tabs.length - 1;
        this.dtg_UpdatedList.focus();
      }
    }
  }

  /**
   * 「変更確定」ボタン押下時の処理
   * @param event
   *
   */
  public eventSaveChangeFixation_ClickHandler(event: Event): void {
    // 串刺しチェック処理
    this.chkSkewer(event);
  }

  /**
   * 更新処理確認メッセージを表示
   *
   */
  private cfmSaveChange(event: Event): void {
    // 更新を確認するメッセージを表示
    this.dialogServiceSub.openAlertGetMessage('Q0108', ['変更内容'],
      (closeDetail) => { // 「はい」を押下した場合、画面を閉じる
        if (closeDetail === PlessAlert.Yes) {
          this.saveChangeFixation(event);
        }
      });
  }

  /**
   * 変更項目をリストに格納し、串刺しチェック処理を呼び出す
   *
   */
  private chkSkewer(event: Event): void {
    const manage: KYMW0901Model = this.kymw0901Model;
    const listArray: Array<any> = new Array<any>();
    // 変更項目を項目ごとにリストに格納
    for (let i: number = <number>0; i < manage.dataKeys.length; i++) {
      const dataKeyArray: Array<any> = manage.tabData[manage.dataKeys[i]];
      if (!PlessViewUtilsSub.isEmptyArray(dataKeyArray)) {
        for (let j: number = <number>0; j < dataKeyArray.length; j++) {
          const list: Array<any> = dataKeyArray[j];
          listArray.push(list);
        }
      }
    }
    // 串刺チェック処理を呼び出す
    this.chkSkewerflg(listArray, listArray.length, 0);
  }

  /**
   * 串刺チェック処理
   * @param list 変更項目リスト
   * @param listsize 変更項目リストサイズ
   * @param count カウント数
   *
   */
  private chkSkewerflg(list: Array<any>, listsize: number, count: number): void {
    // 表示するメッセージを取得
    const message: string = this.makeMessage(list, count);

    // 串刺指定が「0：串刺をしない」、かつ串刺固定が「2：変更優先」
    if (!list[count].skewerSelect && list[count].skewerSelectLock === '2') {
      // 確認メッセージを表示
      this.dialogServiceSub.openAlertGetMessage('Q0151', [message],
        (closeDetail) => { // 「はい」を押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            if (listsize - 1 > count) {
              count = count + 1;
              this.chkSkewerflg(list, listsize, count);
            } else {
              // 次の項目がなければ更新処理確認メッセージを表示
              this.cfmSaveChange(event);
            }
          }
        });
    } else if (!list[count].skewerSelect && list[count].skewerSelectLock === '3') {
      // 串刺指定が「0：串刺をしない」、かつ串刺固定が「3：必須」
      // エラーメッセージを表示
      // その後の処理を行わず、変更確認画面に戻る
      this.dialogServiceSub.openAlertGetMessage('E0258', [message]);
    } else {
      // その他
      // 次の項目があれば次のチェックへ
      if (listsize - 1 > count) {
        count = count + 1;
        this.chkSkewerflg(list, listsize, count);
      } else {
        // 次の項目がなければ更新処理確認メッセージを表示
        this.cfmSaveChange(event);
      }
    }

  }
  /**
   * 表示するメッセージを取得
   * @param list 変更項目リスト
   * @param count カウント数
   * @return message 表示するメッセージ
   *
   */
  private makeMessage(list: Array<any>, count: number): string {
    let message: string = <string>'';

    // 生協コード単位の情報の場合
    if (!PlessViewUtilsSub.isEmpty(list[count].coopCode)) {
      // 「生協名（通称）_変更項目名」を設定
      message = list[count].aliasCoopName + '_' + list[count].changeItemName;
    } else if (!PlessViewUtilsSub.isEmpty(list[count].itemCode)) {
      // アイテムコード単位情報の場合
      // 「アイテムコード_変更項目名」を設定
      message = list[count].itemCode + '_' + list[count].changeItemName;
    } else {
      // Ｐコード単位の情報の場合
      // 「変更項目名」を設定
      message = list[count].changeItemName;
    }
    // メッセージを返却する
    return message;
  }

  private saveChangeFixation(event: any): void {

    const vo: SaveChangeFixationModel = new SaveChangeFixationModel();
    const manage: KYMW0901Model = this.kymw0901Model;
    // 受注コードの格納
    vo.orderCode = manage.orderCode;
    // Ｐコードの格納
    vo.pCode = manage.pCode;
    
    // 各リストの格納
    for (let i = Number(0); i < manage.dataKeys.length; i++) {
      const dataKey = manage.dataKeys[i];
      const tmpArray: Array<any> = manage.tabData[dataKey];

      if (dataKey === 'CommonItem') {
        // 共通項目（Ｐコード）情報の格納
        vo.commonItem.push(...tmpArray);
      } else if (dataKey.includes('CoopItem')) {
        // 生協情報の格納
        vo.coopItem.push(...tmpArray);
      } else if (dataKey.includes('ItemCode')) {
        // アイテム情報の格納
        vo.itemCodeItem.push(...tmpArray);
      } else if (dataKey === 'PreOrder') {
        // 企画予約商品（preOrder）情報を格納
        const preOrderTmpArray = tmpArray.filter(tmp => !tmp._preOrderCoopFlg);
        this.createVO(vo, dataKey, preOrderTmpArray);
        // 企画予約商品利用生協（preOrderCoop）情報を格納
        const preOrderCoopTmpArray = tmpArray.filter(tmp => tmp._preOrderCoopFlg);
        this.createVO(vo, 'PreOrderCoop', preOrderCoopTmpArray);
      } else if (dataKey === 'NvalPromotion') {
        const nvalPromotionTmpArray = tmpArray.map(tmp => {
          if (tmp.changeItemName.includes('追加フラグ') || tmp.changeItemName.includes('削除フラグ')) {
            tmp.changeItemName = tmp.changeItemName.replace('内部処理用_', '');
          }
          return tmp;
        })
        this.createVO(vo, dataKey, nvalPromotionTmpArray);
      } else if (dataKey === 'Coupon') {
        const couponPromotionTmpArray = tmpArray.map(tmp => {
          if (tmp.changeItemName.includes('追加フラグ')) {
            tmp.changeItemName = tmp.changeItemName.replace('内部処理用_', '');
          } else if (tmp.changeItemName.includes('削除フラグ')) {
            tmp.changeItemName = tmp.changeItemName.replace('クーポン情報削除_', '');
          }
          return tmp;
        })
        this.createVO(vo, dataKey, couponPromotionTmpArray);
      } else {
        // その他タブ内情報の格納
        this.createVO(vo, dataKey, tmpArray);
      }
    }
    this.saveChangeFixationService.execute(this.kymw0901Model, vo);
  }

  /**
   * VO作成
   * @param vo SaveChangeFixationModel
   * @param dataKey タブ名に紐づくキー
   * @param itemArray タブ内の表に格納されている配列
   * @returns 
   */
  public createVO(vo, dataKey, itemArray): SaveChangeFixationModel {
    // タブ内情報の取得
    const tabInfoList = this.kymw0901Model.tabInfoList.filter(item => item.tabsInfoKey === dataKey);
    let keyName ='';    // vo判定に使用するキー名

    // 1つのタブに1つのリストを表示している場合
    if (tabInfoList.length == 1) {
      keyName = this.toLowerCaseFirstChara(tabInfoList[0].objName) + 'Item';
      vo[keyName].push(...itemArray);

    } else if (tabInfoList.length > 1) {
      // 1つのタブに複数リストを表示している場合
      let hasSpecKeyName = '';  // 非表示項目の値をもつタブ内情報のキー
      let noSpecKeyName = '';   // 非表示項目の値をもたないタブ内情報のキー
      let specificKey;          // 非表示項目の項目名

      for (const tab of tabInfoList) {
        // 非表示項目の値を持つタブ情報
        if ('specificKey' in tab) {
          hasSpecKeyName = tab.objName;
          specificKey = tab['specificKey'];
        } else {
          noSpecKeyName = tab.objName;
        }
      }
      // 変更項目をそれぞれのvoに格納
      itemArray.forEach((item) => {
        keyName = item[specificKey] ? hasSpecKeyName : noSpecKeyName;
        vo[this.toLowerCaseFirstChara(keyName) + 'Item'].push(item);
      })
    }
    return vo
  }

  public eventClose_CLICKHandler(event: Event): void {
    const vo: object = {
      textInfoDivArray: this.kymw0901Model.textInfoDivArray,
      textKindNumArray: this.kymw0901Model.textKindNumArray,
    };
    this.setKYMW0901Parameter(vo);

    if (this.kymw0901Model.updateComplete) {
      // 企画商品メンテ画面が親画面から受け取ったＰコードの数を取得
      const pCodeCount: number = this.kymw0901Model.pCodeList.length;

      // 企画商品メンテ画面の変更カウントをクリア

      if (pCodeCount > 1 && this.kymw0901Model.updateComplete) {
        // Ｐコードの数が複数の場合

        // 企画商品メンテ変更管理テーブルの最新化（イベント発行）
        // （変更後⇒変更前、変更済フラグクリア、串刺指定クリア）
        // （変更後クリア、串刺固定の串刺指定ＯＮ）
        this.renewPlanGoodsChangeService.execute(this.kymw0901Model, null);
        this.closeFunction(this.kymw0901Model.updateComplete);
        this.kymw0901Model.updateComplete = false;
      } else {
        // 企画メンテ画面、変更確認画面を閉じる。
        this.closeFunction(this.kymw0901Model.updateComplete);
      }
    } else {
      this.kymw0901Model.updateComplete = false;
      this.closeFunction(this.kymw0901Model.updateComplete);
    }
  }

  public nextFocus(event: any): void {
    if (event.keyCode === 9) {
      const tabCount = this.tab_Top.tabs.length;
      if (!event.shiftKey) {
        if (this.tab_Top.selectedIndex === (tabCount - 1)) {
          this.btn_SaveChangeFixation.nativeElement.focus();
        } else {
          this.tab_Top.selectedIndex = this.tab_Top.selectedIndex + 1;
        }
      } else {
        if (this.tab_Top.selectedIndex !== 0) {
          this.tab_Top.selectedIndex = this.tab_Top.selectedIndex - 1;
        } else {
          this.btn_Close.nativeElement.focus();
        }
      }
      event.preventDefault();
    }
  }

  itemsSorceChanged(grid: FlexGrid) {
    setTimeout(() => {
      grid.autoSizeRows();
      grid.select(-1, -1);
    });
  }

  public setFocus() {
    // グリッドの初期更新時、タブ移動時にタブのボタンへフォーカスを充てる
    this.tab_Top.selectedTab.header.focus();
  }

  /**
   * 先頭文字を小文字に変換
   * @param str 
   * @returns 
   */
  public toLowerCaseFirstChara(str: string) {
    if (str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    } else {
      return '';
    }
  }

  /**
   * 串刺のチェック変更イベントハンドラ
   * @param item 
   * @param cellItem 
   */
  public changeCheckHandler(item: any, cellItem: any): void {
    // 1物N価タブ
    if (item === 'NvalPromotion') {
      // 追加・削除串刺し同期処理
      if (cellItem.changeItemName.includes('プロモ設定を追加') || cellItem.changeItemName.includes('プロモ設定を削除')) {
        // 「プロモ設定を追加」「プロモ設定を削除」のチェックが変更されたとき、
        // 同じ1物N価詳細情報IDをもつ情報のチェックも変更する
        for (const e of this.kymw0901Model.tabData[item]) {
          if (e._nvalDetailId === cellItem._nvalDetailId) {
            e.skewerSelect = cellItem.skewerSelect;
          }
        }
      }

      // 供給単価串刺し同期処理
      let supplyPriceChangeFlg = false; // 供給単価変更フラグ
      if (cellItem.changeItemName.includes('プロモ設定を追加') && cellItem.skewerSelect) {
        // 「プロモ設定を追加」のチェックがONに変更されたとき
        // 更新データ側にはチェックON時のみ反映
        supplyPriceChangeFlg = true;
      }
      if (cellItem.changeItemName.substring(0, 4) === '供給単価') {
        // 供給単価の場合
        supplyPriceChangeFlg = true;
      }
      if (supplyPriceChangeFlg) {
        for (const e of this.kymw0901Model.tabData[item]) {
          if (e._itemCode === cellItem._itemCode && e.changeItemName.substring(0, 4) === '供給単価' && e.skewerSelectLock !== '1') {
            // 同じアイテムコードをもつ供給単価のチェックを変更する
            // 活性状態の串刺しにのみ反映する
            // ・追加・削除データには反映しない
            // ・既に非活性の更新データの供給単価は串刺し変更パターンがないため問題なし
            e.skewerSelect = cellItem.skewerSelect;
          }
        }
      }

      // 供給単価ロック判定処理
      let supplyPriceLockFlg = false; // 供給単価ロックフラグ
      for (const e of this.kymw0901Model.tabData[item]) {
        if (e._itemCode === cellItem._itemCode && e.changeItemName.includes('プロモ設定を追加') && e.skewerSelect) {
          // 同じアイテムコードで「プロモ設定を追加」の串刺しのいずれかがONの場合
          supplyPriceLockFlg = true;
          break;
        }
      }
      let bkNvalDetailId = '';
      let addDeleteFlg = false;
      for (const e of this.kymw0901Model.tabData[item]) {
        if (bkNvalDetailId !== e._nvalDetailId) {
          bkNvalDetailId = e._nvalDetailId;
          addDeleteFlg = false;
        }
        if (e.changeItemName.includes('プロモ設定を追加') || e.changeItemName.includes('プロモ設定を削除')) {
          addDeleteFlg = true;
        }
        if (e._itemCode === cellItem._itemCode && e.changeItemName.substring(0, 4) === '供給単価' && !addDeleteFlg) {
          // 同じアイテムコードで供給単価、かつ追加・削除データでない場合
          e.skewerSelectLock = supplyPriceLockFlg ? '1' : '0';
        }
      }
    }
  }
}
